module.exports = "/fonts/ProductSans-Medium.woff?70f0942277dd5cd83980d36681902679";